import { render, staticRenderFns } from "./supervision.vue?vue&type=template&id=c0f3be2a&scoped=true"
import script from "./supervision.vue?vue&type=script&lang=js"
export * from "./supervision.vue?vue&type=script&lang=js"
import style0 from "./supervision.vue?vue&type=style&index=0&id=c0f3be2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f3be2a",
  null
  
)

export default component.exports